import {Component} from "react";
import Datetime from "react-datetime";
import React from "react";
import "./datepicker.css";


export default class MonthPicker extends Component {
    constructor(props) {
        super(props);
        this.valid = this.valid.bind(this);
    }

    valid(current) {
        return current.isAfter(this.props.startDate) && current.isBefore(this.props.endDate);
    }

    render() {
        return  (
            <Datetime dateFormat="YYYY-MM" timeFormat={false} isValidDate={this.valid} value={this.props.value} onChange={this.props.onChange}/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/DatePicker/MonthPicker.jsx